module.exports = __webpack_public_path__ + "static/media/ic-quiz.0108ce31.svg";